import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCommentOnObservation, addCommentOnPost } from "src/shared/services/src";
import { getCurrentChild } from "src/shared/redux-state/src";
import { GlobalErrorActions } from "src/shared/redux-state/src/lib/globalError/GlobalErrorSlice";
import { APP_MESSAGES, ENTITY_TYPE } from "src/shared/config/src";
import { ChildrenStoreData, ReactionCommentData } from "src/shared/types/src";
import CustomTextInput from "./CustomTextInput";
import { FaPaperPlane } from "react-icons/fa";
import CustomButton from "./CustomButton";
import { handleError } from "src/app/utilities/helpers";

interface CommentFooterProps {
    entityId: string;
    entityType: string;
    onAddComment?: (comment: ReactionCommentData | ReactionCommentData[]) => void;
    canLikeComment?: boolean;
}

const CommentFooter: React.FC<CommentFooterProps> = ({ entityId, entityType, onAddComment, canLikeComment }) => {
    const dispatch = useDispatch();
    const currentChild: ChildrenStoreData = useSelector(getCurrentChild);
    
    const [commentText, setCommentText] = useState<string>('');
    const [savingComment, setSavingComment] = useState<boolean>(false);

    const buttonRef: any = useRef(null);

    const handleSubmitEditing = async () => {
        await submitComment();
    };

    const submitComment = async () => {
        if (!canLikeComment) {
            await dispatch(GlobalErrorActions.setError({ isError: true, message: APP_MESSAGES.addCommentErrorOnUnderReviewObservation }));
            return;
        }

        if (savingComment || (!commentText || commentText.trim().length === 0)) return;

        try {
            setSavingComment(true);
            let response;
            if (entityType === ENTITY_TYPE.OBSERVATION) {
                response = await addCommentOnObservation({ child: currentChild, observationId: entityId, commentText });
                if (response && Object.keys(response).length > 0 && onAddComment) {
                    onAddComment(response.comment as ReactionCommentData);
                }
            } else if (entityType === ENTITY_TYPE.EYENGAGE) {
                response = await addCommentOnPost({ child: currentChild, postId: entityId, commentText });
                if (onAddComment) {
                    onAddComment(response?.reactions?.comments?.data as ReactionCommentData[]);
                }
            }

            setCommentText('');
        } catch (error) {
            handleError(error)
            // console.error("Error adding comment: ", error);
            // await dispatch(GlobalErrorActions.setError({ isError: true, message: "An error occurred while adding the comment." }));
        } finally {
            setSavingComment(false);
        }
    };

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' && buttonRef.current) {
            buttonRef.current.click();
        }
    };

    return (
        <div className="d-flex w-100">
            <CustomTextInput
                type="text"
                name="Comment"
                value={commentText}
                placeholder="Write a comment"
                onChange={(e) => setCommentText(e.target.value)}
                customFromGroupStyle={'flex-1'}
                handleKeyDown={handleKeyDown}
            />
            <CustomButton 
                icon={<FaPaperPlane size={20} />} 
                color="primary" 
                onClick={handleSubmitEditing} 
                disabled={savingComment}
                customBtnStyle="w-auto mg-l-15"
                buttonRef={buttonRef}  
            />
        </div>
    );
};

export default CommentFooter;